import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './tag-dropdown.module.css'

/**
 *
 * Tag dropdown container, which shows the tags, when these are grouped.
 *
 * Usage:
 *
 * @example
 * <TagDropdown isOpen={true}>
 *     <Tag ...>
 * </TagDropdown>
 *
 * Notable Props:
 * @property {object} [isOpen]: PropTypes.bool - Show the dropdown as open.
 */

const propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any,
    isOpen: PropTypes.bool.isRequired
}

// We need the class component because of the parent ref
// eslint-disable-next-line react/prefer-stateless-function
export default class TagDropdown extends Component {
    render() {
        const composedClassName = cx(styles['dropdown'], {
            [styles['dropdown-open']]: this.props.isOpen
        })

        return <div className={composedClassName}>{this.props.children}</div>
    }
}

TagDropdown.propTypes = propTypes
